// extracted by mini-css-extract-plugin
export default {"discount":"Ru","order_summary":"Su","line_item":"Tu","separator":"Uu","order__summary_item_title":"Vu","recurringdis":"Wu","get_it_now_button":"Xu"};
    if(module.hot) {
      // 1730991502491
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  